import { useMemo } from 'react';
import { OWNER_ROLE, ROLES_CAP, COMITE_LEVEL_ROLES } from '../utils/Constants';
import { hasRole, hasAnyRole } from '../utils/Utils';

/**
 * Hook para verificar si el usuario tiene permisos para gestionar referidos
 * Solo usuarios con roles Admin, Comité (incluyendo roles de nivel comité) o Instrumentador tienen acceso
 */
export const useReferrerPermissions = () => {
  const hasPermission = useMemo(() => {
    const roles = localStorage.getItem('roles');
    
    if (!roles) {
      return false;
    }

    const isAdmin = hasRole(ROLES_CAP.admin) || hasRole(OWNER_ROLE);
    const isComiteLevel = hasAnyRole(COMITE_LEVEL_ROLES);
    const isInstrumentator = hasRole(ROLES_CAP.instrumentator);

    return isAdmin || isComiteLevel || isInstrumentator;
  }, []);

  return {
    hasPermission,
    canManageReferrers: hasPermission,
  };
};

